import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import { ChevronsRight } from "react-feather"
import ImageCorner from "../../content/assets/imagecorner.svg"
// import PrettyImage from "./pretty-image"

export const AutoLink = css`
  a {
    float: left;
    padding-right: 4px;
    margin-left: -24px;
    fill: var(--color-interactive-light);
    background-image: none;
    :hover {
      background-image: none;
    }
  }
  svg {
    opacity: 0;
    transition: all 200ms linear;
    -webkit-transition: all 200ms linear;
  }
  &:hover {
    a {
      svg {
        opacity: 1;
      }
    }
  }
`

export const StyledH1 = styled.h1`
  margin-top: 48px;
  ${AutoLink};
`

export const StyledH2 = styled.h2`
  margin-top: 48px;
  color: var(--color-heading-inverted);
  ${AutoLink};
`

export const StyledH3 = styled.h3`
  margin-top: 36px;
  ${AutoLink};
`

export const StyledH4 = styled.h4`
  margin-top: 36px;
  ${AutoLink};
`
export const StyledH5 = styled.h5`
  margin-top: 28px;
  ${AutoLink};
`
export const StyledH6 = styled.h6`
  margin-top: 28px;
  ${AutoLink};
`

export const StyledHR = styled.hr`
  border: 2px solid var(--color-primary);
  height: 0px;
`

export const StyledBlockQuote = styled.blockquote`
  padding-bottom: 1.45rem;
  margin-right: 1.45rem;
  margin-left: 1.45rem;
  margin-right: 1.45rem;
  font-style: italic;
  border: var(--color-interactive-light-50) 3px;
  border-left-style: solid;
  padding-left: 25px;
  p {
    display: inline;
  }
`

export const StyledQuote = styled.i`
  font-size: 3rem;
  height: 15px;
  font-weight; bold;
  font-family: serif;
  display: inline-block;
  color: var(--color-interactive-light-50);
  transform: translateY(14px);
  margin-right: 10px;
`

export default function StyledLI({ children }) {
  return (
    <li
      css={css`
        display: block;
        position: relative;
        margin-bottom: 30px;
      `}
    >
      <span
        css={css`
          fill: var(--color-interactive-light);
          display: block;
          position: absolute;
          top: 0px;
          left: 0px;
          transform: translateX(-28px) translateY(1px);
        `}
      >
        <ChevronsRight stroke={"var(--color-interactive-light)"} />
      </span>
      {children}
    </li>
  )
}

export const StyledOL = styled.ol`
  list-style: none;
  counter-reset: counter;
  span {
    display: none;
  }
  li {
    counter-increment: counter;
    ::before {
      content: counter(counter) ". ";
      color: var(--color-interactive-light);
      font-weight: bold;
    }
  }
`

export const StyledStrong = styled.strong`
  color: var(--color-text-bold);
  transition: all 300ms linear;
  -webkit-transition: all 300ms linear;
  &:hover {
    color: var(--color-darker-primary);
  }
`

export const StyledEM = styled.em`
  font-family: Merriweather, serif;
  font-weight: bold;
  font-style: italic;
  color: var(--color-interactive-light);
  transition: all 300ms linear;
  -webkit-transition: all 300ms linear;
  &:hover {
    color: var(--color-darker-primary);
  }
`

export const StyledPre = styled.pre`
  padding: 40px !important;
  border-radius: 25px;
  position: relative;  
  width: 0px;
  overflow: auto !important;
  & > span {
    padding-top: 40px;
    padding-bottom: 40px;
    padding-left: 7px;
  }
  code {
    padding: 0.1em !important;
  }
  @media (max-width: 576px) {
    font-size: 0.9rem !important;
  }
`

export const StyledCode = styled.code`
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
`
// var(--color-gradient-primary),
//       var(--color-gradient-secondary)
export const LinkStyle = css`
  // CSS FOR LINK UNDERLINE
  transition: background-position 0.3s linear, box-shadow 0.15s linear 0s;
  background-image: linear-gradient(
    to right,
    var(--color-gradient-primary),
    var(--color-gradient-primary),
    var(--color-gradient-secondary)
  );
  background-size: 400%;
  background-repeat: no-repeat;
  background-position: 0 1em;
  cursor: pointer;
  text-decoration: none;
  color: var(--color-text);
  font-weight: bold;
  &:hover {
    background-position: 0 0;
    background-image: linear-gradient(
      to right,
      var(--color-gradient-secondary),
      var(--color-gradient-primary),
      var(--color-gradient-primary)
    );
  }
`

export const StyledLink = styled.a`
  ${LinkStyle};
`

export const StyledP = styled.p`
  margin-bottom: 2.5rem;
  a {
    ${LinkStyle};
  }
`

export const H1 = props => {
  return <StyledH1 {...props}>{props.children}</StyledH1>
}

export const H2 = props => {
  return <StyledH2 {...props}>{props.children}</StyledH2>
}

export const H3 = props => {
  return <StyledH3 {...props}>{props.children}</StyledH3>
}

export const H4 = props => {
  return <StyledH4 {...props}>{props.children}</StyledH4>
}

export const H5 = props => {
  return <StyledH5 {...props}>{props.children}</StyledH5>
}

export const H6 = props => {
  return <StyledH6 {...props}>{props.children}</StyledH6>
}

export const HR = props => {
  return <StyledHR {...props}>{props.children}</StyledHR>
}

export const BlockQuote = props => {
  const { children, ...rest } = props
  return (
    <>
      <StyledBlockQuote {...props}>
        <StyledQuote>"</StyledQuote>
        {children}
      </StyledBlockQuote>
    </>
  )
}

export const LI = props => {
  return <StyledLI {...props}>{props.children}</StyledLI>
}

export const OL = props => {
  return <StyledOL {...props}>{props.children}</StyledOL>
}

export const Strong = props => {
  return <StyledStrong {...props}>{props.children}</StyledStrong>
}

export const EM = props => {
  return <StyledEM {...props}>{props.children}</StyledEM>
}

export const A = props => {
  return <StyledLink {...props}>{props.children}</StyledLink>
}

export const Pre = props => {
  return (
    <>
      <StyledPre {...props}>{props.children}</StyledPre>
      <ImageCorner
        css={css`
          stroke: var(--color-gradient-secondary);
          stroke-width: 2px;
          stroke-linecap: round;
          position: absolute;
          bottom: 0px;
          right: 0px;
        `}
      />
    </>
  )
}

export const Code = props => {
  return <StyledCode {...props}>{props.children}</StyledCode>
}

export const P = props => {
  return <StyledP {...props}>{props.children}</StyledP>
}

// export const MarkdownImage = props => {
//   return (
//     <div css={css`
//       width: ${props.width ? props.width : "400px"};
//       height: ${props.height ? props.height : "400px"};
//     `}>
//       <PrettyImage {...props}>{props.children}</PrettyImage>
//     </div>
//   )
// }
